import Home           from './home/Home';
import Login          from './pages/Login';
import Register       from './pages/Register';
import Platform       from './Platform/Platform';
import SurveyResponse from './cliente/SurveyResponse';
import ThanksUser     from './cliente/ThanksUser';
import Contacto       from './home/Contacto';
import AvisoPrivacidad_En from './avisoPri_termin/AvisoPrivacidad_En';
import AvisoPrivacidad_Es from './avisoPri_termin/AvisoPrivacidad_Es';

// ── Factory helpers ────────────────────────────────────────────────────────────
const pub = (path, component, redirectIfAuth = null) => ({
  path, component, requiresAuth: false, redirectIfAuth,
  isPublic: true, isPrivate: false, isPublicNoHeader: false,
});

const noHeader = (path, component) => ({
  path, component, requiresAuth: false, redirectIfAuth: null,
  isPublic: false, isPrivate: false, isPublicNoHeader: true,
});

const priv = (path, component, extra = {}) => ({
  path, component, requiresAuth: true, redirectIfAuth: null,
  isPublic: false, isPrivate: true, isPublicNoHeader: false,
  ...extra,
});

// ── Rutas ─────────────────────────────────────────────────────────────────────
export const routes = [
  // Públicas con header
  pub('',                      Home),
  pub('en',                      Home),
   pub('es',                      Home),
  pub('home',                  Home),
  pub('contacto',              Contacto),
  pub('login',                 Login,    'platform'),
  pub('register',              Register, 'platform'),
  pub('aviso-privacidad-en',   AvisoPrivacidad_En),
  pub('aviso-privacidad-es',   AvisoPrivacidad_Es),
  pub('terminos-servicio-en',  AvisoPrivacidad_En),
  pub('terminos-servicio-es',  AvisoPrivacidad_Es),

  // Públicas sin header
  noHeader('landing',          Register),
  noHeader('surveyRes/:urlId', SurveyResponse),
  noHeader('thank-you',        ThanksUser),

  // Privadas
  priv('platform', Platform, { hasNestedRoutes: true }),
];